import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from './session.jsx';
import { fields as fieldsApi } from './api.js';
import { onPushAction, geolocationSource } from './native.js';

/**
 * Reacts to the field pushes: "Connect" on the notification connects this
 * device to the field (server re-checks proximity); any other tap opens the
 * map on that field so the user can decide there.
 */
export function useFieldAlertActions() {
  const nav = useNavigate();
  const { device, refresh } = useSession();

  useEffect(() => onPushAction(async ({ actionId, data }) => {
    const fieldId = data.field_id;
    if (!fieldId || !data.kind?.startsWith('field_')) return;
    if (data.kind === 'field_enter' && actionId === 'connect' && device) {
      try {
        const pos = await new Promise((ok, fail) => {
          const g = geolocationSource();
          if (!g) return fail(new Error('no location'));
          g.getCurrentPosition((p) => ok(p.coords), fail, { enableHighAccuracy: true, timeout: 10_000 });
        });
        await fieldsApi.checkIn({ deviceId: device.id, fieldId, lat: pos.latitude, lng: pos.longitude });
        await refresh();
        nav(`/map?field=${fieldId}`);
        return;
      } catch (e) { console.warn('connect from push failed', e); }
    }
    if (actionId !== 'dismiss') nav(`/map?field=${fieldId}`);
  }), [device?.id, nav, refresh]);
}
